/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getPropApi } from '../../config/api/Endpoints';
import { ApiEndPointsNames, InitApiType } from '../../types';
import { Bundle } from '../../util';
import Auth0AxiosHelper from './Auth0AxiosHelper';
import HandlePromise from '../../config/api/HandlePromise';

const execApi = (
  apiDomain: ApiEndPointsNames,
  path: string,
  init: InitApiType,
): Promise<any> => {
  const config = Bundle.getValue('config');

  const { apiType, endpoint } = getPropApi(
    config.service.environment,
    apiDomain,
  );
  const isMock = config.service.environment === 'MOCK';
  return HandlePromise(
    Auth0AxiosHelper.request(apiDomain, path, init),
    apiType,
    isMock,
    endpoint,
  );
};

export const post = (
  apiDomain: ApiEndPointsNames,
  path: string,
  init: InitApiType,
): Promise<any> => execApi(apiDomain, path, init);
